import * as React from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { controlClassName } from './input'

export interface SelectProps extends React.ComponentProps<'select'> {
  /** Classes for the wrapper (width, margins); `className` styles the control itself. */
  wrapperClassName?: string
}

/**
 * A native select styled like `Input`, with the design-system chevron. Native
 * on purpose: keyboard, mobile pickers, and form semantics come for free.
 * The DOM reports the chosen option as a string; parse it with the option's
 * schema before storing it.
 */
export function Select({
  ref,
  className,
  wrapperClassName,
  children,
  ...props
}: SelectProps) {
  return (
    <div className={cn('relative', wrapperClassName)}>
      <select
        ref={ref}
        className={cn(
          'flex h-control appearance-none truncate py-1 pr-8 pl-control-x',
          controlClassName,
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-tertiary"
      />
    </div>
  )
}
